module.exports = __webpack_public_path__ + "static/favicon-889db2e547cfcb3b4cefbcb3500663de.png";